import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputCheckboxForm extends ItemForm {
  inputType = 'checkbox';
  override dataGridLabel = true;
  override labelPosition = 'right';
  type = 'checkbox';
  style = {
    'margin-left': 'auto',
  };

  constructor(field: IFormField) {
    super(field);
  }
}
